import { navigate } from 'gatsby';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { bool, object } from 'yup';
import Layout from '@4c/layout';

import BreadCrumbs from '../components/BreadCrumbs';
import CartCard from '../components/CartCard';
import CenterContent from '../components/CenterContent';
import DicomCard from '../components/DicomCard';
import Form from '../components/Form';
import Heading from '../components/Heading';
import PageRoot from '../components/PageRoot';
import PageSegment from '../components/PageSegment';
import paths from '../paths';
import withReservation from '../utils/Reservation';

import styles from '../styles/responsive.module.scss';

const messages = defineMessages({
  dicomRequired: {
    id: 'cart.cloudDicom.required',
    defaultMessage: 'Please make a selection',
  },
});

const schema = object({
  cloudDicom: bool()
    .required(messages.dicomRequired)
    .nullable(),
});

const propTypes = {};

class Cart extends React.Component {
  handleSubmit = async ({ cloudDicom }) => {
    const { cart } = this.props;
    await cart.setState({ cloudDicom });

    navigate(paths.checkout);
  };

  render() {
    const { cart } = this.props;

    return (
      <PageRoot theme="dark">
        <PageSegment theme="light">
          <BreadCrumbs active="checkout" />
          <PageSegment.Content>
            <CenterContent maxWidthMd>
              <Heading level="1" className={styles.textAlignCenterSm}>
                <FormattedMessage
                  defaultMessage="Your Cart"
                  id="checkout.chart.title"
                />
              </Heading>
              <Form
                pad={5}
                as={Layout}
                schema={schema}
                direction="column"
                submitForm={this.handleSubmit}
                defaultValue={{ cloudDicom: this.props.cart.cloudDicom }}
              >
                <PageSegment.FlushContent pad={5}>
                  <CartCard />
                  {!cart.remote.isDeviceOnly && (
                    <Form.Field name="cloudDicom" events="onChange">
                      {props => <DicomCard {...props} />}
                    </Form.Field>
                  )}
                </PageSegment.FlushContent>

                <Layout as={Form.SubmitButton} alignSelf="flex-end">
                  <FormattedMessage
                    defaultMessage="Continue to Checkout"
                    id="checkout.chart.submut"
                  />
                </Layout>
              </Form>
            </CenterContent>
          </PageSegment.Content>
        </PageSegment>
      </PageRoot>
    );
  }
}
Cart.propTypes = propTypes;

export default withReservation(Cart);
